import React, { useMemo } from "react";
import { Field } from "react-final-form";

import RffInputWrapper from "../shared/RffInputWrapper";

import DateTimeInput from "../../inputs/DateTimeInput";
import { normalizeIsoStringToUtc } from "../../../_src_shared/utils/functions/formatDateTime";
import { VALIDATOR_REQUIRE } from "../../../utils/finalForm/validators/VALIDATOR_REQUIRE";

/**
 * A date + clock picker for React Final Form. The value is a UTC ISO instant
 * (`DateTimeInput` emits `toISOString()`), shown in the browser's local clock
 * — the convention for every clocked timestamp the app stores.
 */
const RffDateTimeField = ({
  name,
  label,
  required = false,
  row = false,
  disabled,
  suppressGrid,
  size,
  helperText,
}) => {
  const validate = useMemo(
    () => (required ? VALIDATOR_REQUIRE : undefined),
    [required],
  );

  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      helperText={helperText}
      required={required}
      row={row}
    >
      <Field
        name={name}
        validate={validate}
        render={({ input, meta }) => (
          <DateTimeInput
            {...input}
            // The LOS stores clock times as naive UTC ("2026-09-30T20:15:00");
            // read them as UTC, not as the browser's zone.
            value={typeof input.value === "string" && input.value ? normalizeIsoStringToUtc(input.value) : input.value}
            disabled={disabled}
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error}
          />
        )}
      />
    </RffInputWrapper>
  );
};

export default RffDateTimeField;
